<template>
  <div class="p-16px">
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="机构端 · 分润按日账单：待确认 → 确认/异议（可下钻钉单笔）。运营打款在「紫金山骑手运营端 → 分润打款」。"
    />
    <el-form inline class="mb-12px">
      <el-form-item label="机构 ID">
        <el-input v-model="orgId" class="!w-160px" />
      </el-form-item>
      <el-button type="primary" @click="loadOrg">刷新账单</el-button>
    </el-form>
    <el-table :data="orgBills" size="small" border>
      <el-table-column prop="period" label="日期" width="120" />
      <el-table-column prop="orderCount" label="单量" width="80" />
      <el-table-column prop="amount" label="分润" width="100" />
      <el-table-column prop="status" label="状态" width="120" />
      <el-table-column prop="disputeReason" label="异议原因" min-width="120" />
      <el-table-column label="操作" min-width="220">
        <template #default="{ row }">
          <el-button link type="primary" @click="openLines(row)">明细</el-button>
          <el-button
            v-if="row.status === 'pending_confirm'"
            link
            type="success"
            @click="onConfirm(row.billId)"
          >
            确认
          </el-button>
          <el-button
            v-if="row.status === 'pending_confirm'"
            link
            type="warning"
            @click="onDispute(row.billId)"
          >
            整单异议
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer v-model="linesOpen" title="分润明细" size="420px">
      <el-table :data="lines" size="small" border>
        <el-table-column prop="waybillId" label="运单" min-width="120" />
        <el-table-column prop="amount" label="分润" width="80" />
        <el-table-column label="操作" width="100">
          <template #default="{ row }">
            <el-button
              v-if="activeBill?.status === 'pending_confirm'"
              link
              type="warning"
              @click="onDisputeLine(row.waybillId)"
            >
              钉异议
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script lang="ts" setup>
import * as WalletApi from '@/api/capacity/org-wallet'
import { ElMessage, ElMessageBox } from 'element-plus'

defineOptions({ name: 'MerchantCapacitySettle' })

const orgId = ref(localStorage.getItem('capacityOrgId') || 'org_1')
const orgBills = ref<WalletApi.OrgBill[]>([])
const linesOpen = ref(false)
const lines = ref<WalletApi.CommissionEntry[]>([])
const activeBill = ref<WalletApi.OrgBill | null>(null)

const loadOrg = async () => {
  if (!orgId.value) {
    orgId.value = localStorage.getItem('capacityOrgId') || ''
  }
  if (!orgId.value) {
    orgBills.value = []
    return
  }
  orgBills.value = await WalletApi.listOrgBills(orgId.value)
}

const openLines = async (row: WalletApi.OrgBill) => {
  activeBill.value = row
  lines.value = await WalletApi.listBillLines(orgId.value, row.billId)
  linesOpen.value = true
}

const onConfirm = async (billId: string) => {
  const r = await WalletApi.confirmBill(orgId.value, billId)
  if (!r.success) return ElMessage.error(r.message || '确认失败')
  ElMessage.success('已确认')
  await loadOrg()
}

const onDispute = async (billId: string) => {
  const { value } = await ElMessageBox.prompt('异议原因', '分润异议', {
    inputValue: '金额不符'
  })
  const r = await WalletApi.disputeBill(orgId.value, billId, value)
  if (!r.success) return ElMessage.error(r.message || '异议失败')
  ElMessage.success('已提交异议')
  await loadOrg()
}

const onDisputeLine = async (waybillId: string) => {
  if (!activeBill.value) return
  const { value } = await ElMessageBox.prompt('单笔异议原因', '钉运单', {
    inputValue: '金额不符'
  })
  const r = await WalletApi.disputeBillLine(
    orgId.value,
    activeBill.value.billId,
    waybillId,
    value
  )
  if (!r.success) return ElMessage.error(r.message || '异议失败')
  ElMessage.success('已钉单笔异议')
  linesOpen.value = false
  await loadOrg()
}

onMounted(loadOrg)
</script>
